export enum AppointmentState {
  waiting = 1,
  picked_up = 2,
  cancelled = 3,
}

export const AppointmentStates = new Set([
  AppointmentState.waiting,
  AppointmentState.picked_up,
  AppointmentState.cancelled,
]);